export const USERS_LIST_ACTION = "USERS_LIST_ACTION"
export const ADD_USER_ACTION = "ADD_USER_ACTION";
export const UPDATE_USER = 'UPDATE_USER';


export const userSList=(usersList)=>({
    type: USERS_LIST_ACTION ,
    payload: usersList

})



export const addUser = (newUserProfile) => ({
    type: ADD_USER_ACTION,
    payload: newUserProfile,
});

export const updateUser = (userData) => ({
    type: UPDATE_USER,
    payload: userData,
  });

  